import { ReactNode } from 'react';
import cx from 'classnames';

import s from './styles.module.scss';

interface ILayoutHeader {
  collapsed: boolean;
  children: ReactNode;
}

const Header = ({ collapsed, children }: ILayoutHeader) => (
  <div className={cx(s.header, collapsed && s.headerCollapsed)}>{children}</div>
);

export default Header;
